module.exports = __webpack_public_path__ + "img/99b4692.png";